export default __webpack_public_path__ + "static/media/Bandeau 6.7b8d12d3.jpg";